<template>
    <div>
      <Loading :value="loading"></Loading>
  
      <!--  MODAL VALIDATION MISSION-->
      <v-dialog
        v-model="dialogDetail"
        transition="dialog-bottom-transition"
        scrollable
        :loading="loading"
        fullscreen
        hide-overlay
      >
        <v-card>
          <v-toolbar card dark color="primary">
            <v-toolbar-title
              >Fiche de Validation du bon de commande interne
              {{ detailCommande.ref }}</v-toolbar-title
            >
            <v-spacer></v-spacer>
            <v-btn icon dark @click.native="closeDialog()">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
  
          <v-card-text>
            <v-layout>
              <v-flex>
                <v-card color="" class="mb-5" flat>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-alert :value="true" outline color="purple" icon="info">
                        Informations générales
                      </v-alert>
  
                      <v-card flat>
                        <v-layout wrap>
                          <v-card-text>
                            <v-flex xs12>
                              <v-flex xs12 class="text-xs-left">
                                <!--HAUT-->
                                <v-layout row>
                                  <v-flex xs6 class="mr-4">
                                    <!--COLONNE 1-->
                                    <v-layout row>
                                      <v-flex xs2>Projet</v-flex>
                                      <v-flex xs10 class="text-xs-right title">
                                        {{ detailCommande.projet }}
                                      </v-flex>
                                    </v-layout>
                                    <v-divider class="mb-3"></v-divider>
  
                                    <v-layout row>
                                      <v-flex xs2>Chantier</v-flex>
                                      <v-flex xs10 class="text-xs-right title">
                                        {{ detailCommande.chantier }}
                                      </v-flex>
                                    </v-layout>
                                    <v-divider class="mb-3"></v-divider>
  
                                    <v-layout row>
                                      <v-flex xs2>Travaux</v-flex>
                                      <v-flex xs10 class="text-xs-right title">
                                        {{ detailCommande.travaux }}
                                      </v-flex>
                                    </v-layout>
                                    <v-divider class="mb-3"></v-divider>
                                    <v-layout row>
                                      <v-flex xs2>Tâches</v-flex>
                                      <v-flex xs10 class="text-xs-right title">
                                        <span
                                          v-for="(item,
                                          index) in detailCommande.tache"
                                          :key="index"
                                        >
                                          <v-chip outline label>
                                            {{ item }}
                                          </v-chip>
                                          /
                                        </span>
                                      </v-flex>
                                    </v-layout>
                                    <v-divider class="mb-3"></v-divider>
                                  </v-flex>
  
                                  <v-flex xs6 class="mr-4">
                                    <!--COLONNE 1-->
                                    <v-layout row>
                                      <v-flex xs6>PK début</v-flex>
                                      <v-flex xs6 class="text-xs-left title">
                                        {{ detailCommande.tranconA }}
                                      </v-flex>
                                    </v-layout>
                                    <v-divider class="mb-3"></v-divider>
                                    <v-layout row>
                                      <v-flex xs6>PK fin</v-flex>
                                      <v-flex xs6 class="text-xs-left title">
                                        {{ detailCommande.tranconB }}
                                      </v-flex>
                                    </v-layout>
                                    <v-divider class="mb-3"></v-divider>
  
                                    <v-layout row>
                                      <v-flex xs6>Date de la livraison</v-flex>
                                      <v-flex xs6 class="text-xs-left title">
                                        {{ detailCommande.dateLivr }}
                                      </v-flex>
                                    </v-layout>
                                    <v-divider class="mb-3"></v-divider>
  
                                    <v-layout row>
                                      <v-flex xs6>Demandeur</v-flex>
                                      <v-flex xs6 class="text-xs-left title">
                                        {{ detailCommande.user }}
                                      </v-flex>
                                    </v-layout>                                 
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-flex>
                          </v-card-text>
                        </v-layout>
                      </v-card>
                    </v-flex>
                    <v-flex xs12 class="text-xs-right">
                      <v-tooltip top>
                        <v-btn
                          slot="activator"
                          v-if="urlImage"
                          icons
                          color="orange"
                          id="intro"
                          @click="showDiapo([urlImage], 0, urlImage)"
                          dark
                          >Voir la pièce justificatif
                          <v-icon right>list</v-icon></v-btn
                        >
                        Voir la pièce justificatif
                      </v-tooltip>
                    </v-flex>
                    <CoolLightBox
                      :items="items"
                      :index="index"
                      @close="index = null"
                    >
                    </CoolLightBox>
  
                    <v-flex xs12>
                      <v-alert :value="true" outline color="purple" icon="info">
                        liste des ressources
                      </v-alert>
                    </v-flex>
  
                    <v-layout row wrap>
                      <!-- <v-flex xs12> -->
                        <el-table
                          class="text-center"
                          :data="detailCommande.option"
                          border
                        >
                          <el-table-column
                            prop="codeAnalytique"
                            class="text-center"
                            label="Code analytique"
                          >
                            <template slot-scope="scope">
                              <b>{{scope.row.codeAnalytique }}</b>   
                            </template>
                          </el-table-column>
  
                          <el-table-column prop="codeGestion" label="Code de gestion">
                              <template slot-scope="scope">
                                  <b>{{scope.row.codeGestion }}</b>   
                            </template>
                          </el-table-column>
                          <el-table-column width="400"  prop="produit" label="Ressource">
                            <template slot-scope="scope">
                              <v-chip
                              text-color="white"
                              label
                              fab
                              color="orange accent-3"
                              >{{scope.row.produit }}</v-chip>                           
                            </template>
                          </el-table-column>
                          <el-table-column width="80" prop="unite" label="unité">
                            <template slot-scope="scope">
                              <b>{{scope.row.unite }}</b>   
                            </template>
                          </el-table-column>
                          <el-table-column width="250"  prop="qte" label="Quantité commandé">
                            <template slot-scope="prop">
                              <el-input-number
                                :min="0"                            
                                name="qte"
                                v-model="prop.row.qte"
                              ></el-input-number>
                            </template>
                          </el-table-column>
                          <el-table-column prop="qteStock" label="Quantité en stock">
                            <template slot-scope="scope">                           
                              <b>{{new Intl.NumberFormat("fr-Fr").format(scope.row.qteStock) }}</b>   
                            </template>
                          </el-table-column>
  
                          <el-table-column prop="budgetPre" label="Budget Prévu">
                              <template slot-scope="scope">                           
                              <b>{{new Intl.NumberFormat("fr-Fr").format(scope.row.budgetPre) }}</b>   
                            </template>
                          </el-table-column>
  
                          <el-table-column prop="totalDepn" label="Budget Engagé">
                            <template slot-scope="scope">                           
                                <b>{{new Intl.NumberFormat("fr-Fr").format(scope.row.totalDepn) }}</b>   
                            </template>
                          </el-table-column>
  
                          <el-table-column prop="budgetR" label="Budget Restant">
                              <template slot-scope="scope">                           
                                <b>{{new Intl.NumberFormat("fr-Fr").format(scope.row.budgetR) }}</b>   
                            </template>
                          </el-table-column>
                          <el-table-column label="Opérations" align="center">
                            <template slot-scope="scope">
                              <v-tooltip top>
                                <v-btn
                                  slot="activator"
                                  fab
                                  small
                                  icons
                                  color="red"
                                  @click.native.prevent="dialogSupr = true;
                                    deleteRow(scope.$index, detailCommande.option)
                                  "
                                  dark
                                >
                                  <v-icon center>delete</v-icon>
                                </v-btn>
                                Supprimer cette tâche
                              </v-tooltip>
                            </template>
                          </el-table-column>
                        </el-table>
                      <!-- </v-flex> -->
                    </v-layout>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card-text>
  
          <div style="flex: 1 1 auto;"></div>
        </v-card>
  
        <v-tooltip top>
          <v-btn
            class="mb-5"
            style="margin-right: 100px"
            absolute
            slot="activator"
            dark
            fab
            large
            bottom
            right
            color="red"
            @click="dialogConfirmRefus = true"
          >
            <v-icon>close</v-icon>
          </v-btn>
          <span>Rejeter la commande</span>
        </v-tooltip>
  
        <v-tooltip top>
          <v-btn
            class="mb-5 ml-5"
            absolute
            slot="activator"
            dark
            fab
            large
            bottom
            right
            color="green"
            @click="dialogConfirm = true"
          >
            <v-icon>done</v-icon>
          </v-btn>
          <span>Valider la commande</span>
        </v-tooltip>
      </v-dialog>
      <!-- FIN MODAL VALIDATION MISSION-->
  
      <!-- CONFIRMATION REFUS DEMANDE -->
      <v-layout row justify-center>
        <v-dialog v-model="dialogConfirmRefus" persistent max-width="650">
          <v-card>
            <v-card-title class="headline"
              >Validation du bon de commande interne</v-card-title
            >
            <v-card-text>
              <v-layout wrap>
                <v-flex xs12 class="mb-2">
                  <el-alert
                    title="Voulez vous Refuser ce bon de commnde ?"
                    :closable="false"
                    show-icon
                    type="error"
                  >
                  </el-alert>
                </v-flex>
                <v-flex xs12>
                  <p class="grey--text font-weight-thin body-1">
                    COMMANDE REFERENCE
                  </p>
                  <p class="black--text .font-weight-regular subheading">
                    {{ detailCommande.ref }}
                  </p>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="grey darken-1"
                dark
                @click.native="dialogConfirmRefus = false"
                >Annuler</v-btn
              >
              <v-btn
                color="red darken-1"
                dark
                @click.native="SubmitValideDevis('rejeter')"
                >Refuser</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
  
      <!-- CONFIRMATION VALIDATION -->
      <v-layout row justify-center>
        <v-dialog v-model="dialogConfirm" persistent max-width="650">
          <v-card>
            <v-card-title class="headline"
              >Validation d'un bon de commande interne (bci)</v-card-title
            >
            <v-card-text>
              <v-layout wrap>
                <v-flex xs12 class="mb-2">
                  <el-alert
                    title="Voulez vous valider ce bon de commande interne ?"
                    :closable="false"
                    show-icon
                    type="success"
                  >
                  </el-alert>
                </v-flex>
                <v-flex xs12>
                  <p class="grey--text font-weight-thin body-1">
                    BON DE COMMANDE REFERENCE
                  </p>
                  <p class="black--text .font-weight-regular subheading">
                    {{ detailCommande.ref }}
                  </p>
  
                <v-flex xs12>
                  <el-form
                    id="formRefus"
                    ref="refFormRefust"
                    label-position="top"
                    :inline="true"
                    :model="formRefus"
                    class="demo-form-inline"
                  >
                    <v-flex xs12>
                      <el-form-item
                        style="width:100%"
                        label="Commentaire"
                        prop="rapportRefus"
                      >
                        <el-input
                          style="width:100%"
                          type="textarea"
                          :rows="6"
                          placeholder="Commentaire"
                          v-model="formRefus.rapport"
                        ></el-input>
                      </el-form-item>
                    </v-flex>
                  </el-form>
                </v-flex>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="grey darken-1"
                dark
                @click.native="dialogConfirm = false"
                >Annuler</v-btn
              >
              <v-btn
                color="green darken-1"
                dark
                @click.native="SubmitValideDevis('confirme')"
                >Confirmer</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
  
       <!-- MODAL SUPPRESSION -->
       <v-dialog
        v-model="dialogSupr"
        max-width="50%"
        :overlay="true"
        scrollable
        persistent
      >
        <v-card>
          <v-card-text text-xs-center>
            <h3 align="center">
              Voulez-vous vraiment supprimer cette ligne ?
            </h3>
            <p align="center">
              <v-btn @click.native="dialogSupr = false" color="orange" dark
                >Annuler <v-icon right>remove_circle</v-icon></v-btn
              >
              <v-btn icons color="red" @click.stop="deleteBesoin()" dark
                >Supprimer <v-icon right>delete</v-icon></v-btn
              >
            </p>
          </v-card-text>
          <div style="flex: 1 1 auto;"></div>
        </v-card>
      </v-dialog>
  
    </div>
  </template>
  
  <script>
  import Loading from "@/components/Loading";
  export default {
    components: { Loading },
    name: "ModalValidationDga",
    props: ["show", "detailCommande", "totalMontant"],
    data() {
      return {
        //data general
        domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
        user: JSON.parse(sessionStorage.getItem("userInfo")),
        roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
        droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
        loading: false,
        dialogDetail: false,
        listeTacheSupp: [],
        dialogSupr: false,
        index:'',
        indexRow:'',
        indexLigne:'',
        indexRowLigne:'',
        dialogVisible: false,
        dialogConfirmRefus: false,
        logoPdf: "/static/pdf.png",
        dialogConfirm: false,
        formRefus: {},
        items: [],
        index: null,
        urlImage: "",
        ruleFormRefus: {
          rapportRefus: [{ required: true, message: "Veuillez saisir" }]
        }
      };
    },
  
    computed: {},
    watch: {
      show: function(newValue, oldvalue) {
        this.dialogDetail = newValue;
        this.urlImage = this.detailCommande.urlImage;
        console.log("detailCommande", this.detailCommande);
  
        if (newValue == true) {
          //this.loadDevisConstat()
        }
      }
    },
  
    methods: {
      successNotif(mess = "") {
        this.$notify({
          title: "ENREGISTREMENT REUSSI",
          message: mess,
          type: "success",
          position: "top-center"
        });
      },
  
      showDiapo(images, ind, image) {
        this.items = images;
        this.index = ind;
      },
      closeDialog(item = null) {
        console.log("item", item);
        if (item == "images") {
          this.index = null;
        } else {
          this.$emit("close", this.detailCommande.id, "bonCommandeInterne");
        }
      },
      deleteBesoin() {
          this.this.listeTacheSupp = []
          if (this.detailCommande.option[this.indexLigne].id != null) {
              this.listeTacheSupp.push(this.detailCommande.option[this.indexLigne].id);
          }
          this.indexRowLigne.splice(this.indexLigne, 1);        
          this.dialogSupr = false;
      },
      deleteRow(index, rows) {
          this.indexLigne = index
          this.indexRowLigne = rows
      },
      SubmitValideDevis(item) {
        this.loading = true;
        let url = this.domaine + "besoin/avalider/bci/nivau3";
  
        let data = new FormData();
        data.append("decision", item == "confirme" ? 1 : 0);
        data.append("commDec", this.formRefus.rapport);
        data.append("idUser", this.user.id);
        data.append("bci", this.detailCommande.id);
        data.append("listeSupp", JSON.stringify(this.listeTacheSupp));
        // on recupere le tableau
        for (let prop in this.detailCommande.option) {
              let ligne = this.detailCommande.option[prop];
              data.append("options[id][]", ligne.id);
              data.append("options[qte][]", ligne.qte);
          }
        this.$http.post(url, data).then(
          response => {
            this.loading = false;
            this.dialogConfirmRefus = false;
            this.dialogConfirm = false;
            this.formRefus.rapport = "";
            this.successNotif(response.body.message);
            this.closeDialog();
          },
          errResp => {
            this.loading = false;
            this.$message.error(
              "Une erreur est survenue lors de la validation de la mission"
            );
          }
        );
      },
      SubmitRefusDevis() {
        this.loading = true;
        let url = this.domaine + "besoin/avalider/bci/nivau3";
        var data = new FormData();
        data.append("decision", item == "confirme" ? 1 : 0);
        data.append("commDec", this.formRefus.rapport);
        data.append("bci", this.detailCommande.id);
        data.append("user", this.user.id);
  
        this.$http.post(url, data).then(
          response => {
            this.loading = false;
            this.successNotif(response.body.message);
            this.dialogConfirmRefus = false;
            this.closeDialog();
          },
          errResp => {
            this.loading = false;
            this.$message.error(
              "Une erreur est survenue lors du refus de la demande de mission"
            );
          }
        );
      }
    },
    mounted() {}
  };
  </script>
  <style scoped></style>



// WEBPACK FOOTER //
// src/components/validationDG/ModalValidationDga.vue